// ─────────────────────────────────────────────────────────────────
// Sehat AI — SoundWave Animation Component
// ─────────────────────────────────────────────────────────────────

import React from 'react';

export default function SoundWave({ color = '#FF6B35', barCount = 7 }) {
  const heights = [5, 10, 7, 14, 9, 12, 6];
  return (
    <div style={{ display: 'flex', gap: 3, alignItems: 'center', height: 18 }}>
      {heights.slice(0, barCount).map((h, i) => (
        <div
          key={i}
          style={{
            width: 3, height: h, background: color, borderRadius: 2,
            animation: `sw 0.65s ease ${i * 0.08}s infinite alternate`,
          }}
        />
      ))}
    </div>
  );
}
